enum DocumentType {
  Excel = "excel",
  Generic = "generic",
  Image = "image",
  PDF = "pdf",
  Word = "word",
}

const DocumentExtensions = {
  Excel: ["xls", "xlsx"],
  Image: ["jpg", "jpeg", "png"],
  PDF: ["pdf"],
  Word: ["doc", "docx"],
};

enum DocumentMimeType {
  BMP = "image/bmp",
  DOC = "application/msword",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  GIF = "image/gif",
  HEIC = "image/heic",
  JPEG = "image/jpeg",
  JPG = "image/jpg",
  PDF = "application/pdf",
  PNG = "image/png",
  SVG = "image/svg+xml",
  TIFF = "image/tiff",
  WEBP = "image/webp",
  XLS = "application/vnd.ms-excel",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}

// manually  mirrors file-service's supported extensions per use case
// adding a DocumentMimeType here that isn't supported for that usecase will result in a vague error message on upload
const AcceptedDocumentMimeTypes: Record<string, DocumentMimeType[]> = {
  // on native, explicitly PDF + implicitly the image types the device "Choose from library" picker accepts
  // on web, this constant is re-used for UploadInsurance to show PDF + nativeImageDocTypes
  // (while InsuranceUpload *is* PatientDocumentUpload, which allows .doc/.docx/.xls/.xlsx, excluded as not meant to be used here)
  InsuranceUpload: [
    DocumentMimeType.PDF,
    DocumentMimeType.JPEG,
    DocumentMimeType.JPG,
    DocumentMimeType.PNG,
  ],
  // see: https://github.com/equiphealth/file-service/blob/main/src/main/resources/db/migration/V20250904102012__add_new_context_for_meal_image_upload.sql
  MealImageUpload: [
    DocumentMimeType.BMP,
    DocumentMimeType.GIF,
    // non-Safari browsers can't render HEIC; heic-to library used to render on view, and convert-to-jpg on SMT upload
    DocumentMimeType.HEIC,
    DocumentMimeType.JPEG,
    DocumentMimeType.JPG,
    DocumentMimeType.PNG,
    DocumentMimeType.SVG,
    // non-Safari browsers can't render TIFF; on mobile SMT upload converts to JPG first, on web SMT upload disallows TIFF
    DocumentMimeType.TIFF,
    DocumentMimeType.WEBP,
  ],
  // see: https://github.com/equiphealth/file-service/blob/main/src/main/resources/db/migration/V20251125164941__add_patient_document_upload_context_code.sql
  PatientDocumentUpload: [
    DocumentMimeType.DOC,
    DocumentMimeType.DOCX,
    DocumentMimeType.PDF,
    DocumentMimeType.XLS,
    DocumentMimeType.XLSX,
    DocumentMimeType.JPEG,
    DocumentMimeType.JPG,
    DocumentMimeType.PNG,
  ],
};

enum DocumentFileSource {
  Chat = "CHAT",
  Doc = "DOC",
  Note = "NOTE",
  Task = "TASK",
}

enum DocumentCategory {
  LabOrders = "LAB_ORDERS",
  Labs = "LABS",
  Patient = "PATIENT",
  Task = "TASK",
}

enum DocumentTag {
  Insurance = "INSURANCE",
}

// only enumerating void reason codes relevant to the mobile app (no providers)
// all other void reason codes are specific to maud/equip-vesta/provider usage
enum DocumentVoidReasonCode {
  Other = "OTHER",
}

export {
  AcceptedDocumentMimeTypes,
  DocumentCategory,
  DocumentExtensions,
  DocumentFileSource,
  DocumentMimeType,
  DocumentTag,
  DocumentType,
  DocumentVoidReasonCode,
};
